'use strict';

import features0 from "../../../../server/public/static/contact/features-0.png"
import features1 from "../../../../server/public/static/contact/features-1.png"
import features2 from "../../../../server/public/static/contact/features-2.png"
import features3 from "../../../../server/public/static/contact/features-3.png"

// import from item-detail.jsx
const PRODUCT_THUMB_W = 600;

const isNode = typeof document === 'undefined';

const _ = require('lodash');
const React = require('react');
const ReactRouter = require('react-router');
const SuperAgent = require('superagent');
const LinkedStateMixin = require('react-addons-linked-state-mixin');
import { Helmet } from 'react-helmet';

const History = ReactRouter.History;

const Actions = require('../../store').Actions;
const Constants = require('../../constants');
const Global = require('../../global');

const ResponsiveMixin = Global.ResponsiveMixin;
const ParseAPI = Global.ParseAPI;

const Breadcrumbs = require('../breadcrumbs.jsx');
const SeriesItems = require('./series-items.jsx');

const ItemDetail = require('./experiment-product-page-with-form-item-detail.jsx');

if (!isNode) {
    require('./experiment-product-page-with-form-product-page.scss');
    require('../../pages/content/contact.scss');
}

// CONTACT METHOD COMPONENTS
var ContactMethod = props => {
  return (
    <div className="pg-contact-method">
      <div className="pg-contact-title">{props.title1}</div>
      <div className="pg-contact-detail">
        <div className="pg-contact-detail-children">{props.children}</div>
      </div>
    </div>
  );
};

var ContactMethods = React.createClass({
  mixins: [ResponsiveMixin],

  render: function() {
    return (
      <div className="pg-contact-methods">
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Call us toll free" title2="">
            <a href="tel:888-871-5777">888-871-5777</a>
          </ContactMethod>
        </span>
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Int'l customers" title2="">
            <a href="tel:+1-310-321-5995">+1-310-321-5995</a>
          </ContactMethod>
        </span>
        <span className="pg-contact-method-wrapper">
          <ContactMethod title1="Write to us" title2="">
            <a href="#form" style={{textTransform: "uppercase"}}>Email Us</a>
          </ContactMethod>
        </span>
        <a
          href="https://goo.gl/maps/qPJwb8ArJg12"
          target="_blank"
          className="pg-contact-method-wrapper"
          rel="noreferrer"
        >
          <ContactMethod title1="Visit by appointment" title2="" icon="">
            <span className="pg-contact-address-street">123 Richmond St.</span>
            <br />
            <span className="pg-contact-address-city">
              El Segundo, California
            </span>
          </ContactMethod>
        </a>
     </div>
    );
  }
});

var ContactServicesItems = props => {
    var items = props.services.map((item, i) => {
      return (
        <div className="serviceItem" key={i}>
          <div className="serviceTitleWrapper">
            <div className="serviceImage">
              <img src={item.image} width={item.width} height={item.height} alt={item.title || 'service'} />
            </div>
            <div className="serviceTitle">{item.title}</div>
          </div>
          <div className="serviceDetails">{item.details}</div>
        </div>
      );
    });
  
    return <div className="pg-services-items">{items}</div>;
  };

  class ContactVideoBlock extends React.Component {
    constructor(props) {
      super(props);
      this.state = { videoVisible: false, coverVisible: true };
      this.playVideo = this.playVideo.bind(this);
    }
  
    playVideo(e) {
      e.stopPropagation();
      this.setState({
        coverVisible: false,
        videoVisible: true,
      });
    }
    render() {
      return (
        <div className="pg-video-wrapper">
          <h3>WHAT OUR CLIENTS SAY ABOUT US</h3>
          <div className="pg-video">
            {this.state.coverVisible &&
              <div
              onClick={this.playVideo}
              style={{ display: "block" }}
              >
                <picture>
                  <source srcSet={`${Payload.webp}/contact/videoThumb.jpg.webp`} type="image/webp" />
                  <source srcSet={`${Payload.static}/contact/videoThumb.jpg`} type="image/jpeg" />
                  <img src={`${Payload.static}/contact/videoThumb.jpg`} width="900" height="506" style={{ cursor: "pointer" }} alt="video thumb" />
                </picture>
              </div>
            }
            {this.state.videoVisible &&
            <div style={{ display: "block" }}>
              <iframe
                src="https://player.vimeo.com/video/123676395?color=1d9fdd&title=0&byline=0&portrait=0"
                frameBorder="0"
                allowFullScreen
                title="Vimeo player"
                ></iframe>
            </div>
            }
          </div>
        </div>
      );
    }
  }
  

/* React component plan:
    - ItemDetail        co-item-detail
        - <div>
            - ItemImage         co-item-thumb
                                    <a>
                                        co-item-thumb-container
                                            img
                                            Pinterest
            - GroupItems        co-item-series
        - <div>
            - ItemTabs
                - StackableTabs     co-item-tabs
                                        co-item-tab-bar
                    - ItemTab*
                    - ItemTabs              co-item-tab-body
                        - ItemTabStory
                        - ItemTabGallery
                        - ItemTabSize
                            - ItemTabMomaGallery
                            - ItemTabDynamicGallery
            - ItemControls
*/

const ProductDetail = React.createClass({
    mixins: [ History, LinkedStateMixin, ResponsiveMixin ],

    getInitialState: function() {
        const state = {
            item: Payload.Item ? Payload.Item : null,
            groupItems: Payload.Item ? Payload.Item.groupItems : null,
            loading: false,
            loadingFromPayload: Payload.Item ? true : false,
        };

        let groupItemsIndex,
            relatedItemsIndex;

        if (typeof history !== 'undefined' && history.state && history.state.groupItemsIndex) {
            groupItemsIndex = history.state.groupItemsIndex;
        } else {
            groupItemsIndex = state.groupItems && state.groupItems.findIndex(item => {
                return item.id == state.item.item.id;
            });
        }

        if (typeof history !== 'undefined' && history.state && history.state.relatedItemsIndex) {
            relatedItemsIndex = history.state.relatedItemsIndex;
        } else {
            relatedItemsIndex = 0;
        }

        state.groupItemsIndex = groupItemsIndex;
        state.relatedItemsIndex = relatedItemsIndex;

        return state;
    },
    componentWillMount: function() {
        // If initial page load from Payload, show footer immediately - otherwise trigger XHR fetch
        if (!this.state.loadingFromPayload) {
            this.load(this.props.params.itemID);
        } else {
            this.props.showFooter.requestChange(true);
        }
    },
    componentDidMount: function() {
        // If user navigates back into Item from an initial Item load, XHR request wasn't being made. Setting this to null prevents that problem.
        // But probably we can get refactor out loadingFromPayload.
        Payload.Item = null;

        this.setState({
            loadingFromPayload: false,
        });
    },
    componentDidUpdate: function(prevProps, prevState) {
        // If initial load from Payload, do nothing
        if (prevState.loadingFromPayload && !this.state.loadingFromPayload) {
            return;
        }
        if (!this.state.loading && this.state.item && this.props.params.itemID != this.state.item.item.id) {
            var _this = this;
            this.setState({
                loading: true,
            }, function() {
                _this.load();
            });
        }
    },
    load: function(itemID) {
        if (!isNode) {
            // Hide the footer before loading XHR (prevent flash of footer)
            this.props.showFooter.requestChange(false);
            var query = {
                command: 'item',
                itemID: this.props.params.itemID,
            };
            SuperAgent
                .get('/collections.json')
                .query(query)
                .end((err, res) => {
                    var item = ParseAPI(query, err, res);
                    if (!item) {
                        return;
                    }
                    this.setState({
                        item: item,
                        groupItems: item.groupItems,
                        loading: false,
                    }, () => {
                        // Add item to Recently Viewed
                        Actions.viewedItem(this.state.item.item);

                        // Show the footer now everything is loaded
                        this.props.showFooter.requestChange(true);
                    });
                });
        }
    },
    render: function() {
        if (!this.state.item)
            return null;

        return (
            <div className='co-item'>
                <ItemSchema itemID={this.props.params.itemID} {...this.state.item.item} />
                <ItemOpenGraph productPage={this.state.item} />

                <div className='co-header'>
                    <Breadcrumbs trail      = {this.state.item.breadcrumbs}
                                 categories = {Payload.Collections}
                                 params     = {this.props.params} />
                </div>
                <ItemDetail item              = {this.state.item}
                            params            = {this.props.params}
                            location          = {this.props.location}

                            groupItems        = {this.state.groupItems}

                            groupItemsIndex   = {/* GroupItems will update its own index when paged so needs to be linkedState */
                                                 this.linkState('groupItemsIndex')}
                                                
                            relatedItemsIndex = {/* relatedItemsIndex doesn't have to be linkedState but for consistency with groupItemsIndex */
                                                 this.linkState('relatedItemsIndex')}

                            router = {this.props.router} />

            <div className="quicklinks-wrapper">
            <h3 className="title">Complete your workspace with our other products</h3>
            <div className="quicklinks">
              {[
                  {label: 'Modern Office Desks', link: '/office-furniture-desk'},
                  {label: 'Modern Cubicles', link: '/modular-office-furniture-workstation-cubicle'},
                  {label: 'Conference Tables', link: '/modern-conference-tables'},
                  {label: 'Reception Desks', link: '/reception-desk-station-office'},
                  {label: 'Collaborative Furniture', link: '/collaboration-furniture'},
                  {label: 'Office Chairs', link: '/office-chair'},
                  {label: 'Acoustic Furniture', link: '/acoustic-office-furniture-sound-absorbing'},
                  {label: 'Sit-Stand Desks', link: '/adjustable-height-desks'}
              ].map((item, i) => 
                <a href={item.link} className="ql-button" key={i}>{item.label}</a>
              )}
            </div>
          </div>
      
          <div className="pg-services-wrapper">
            <div className="image-wrapper">
              <img src="/static/page-detail/Total_Office_Scene_01.jpg" />
              <img src="/static/page-detail/SP_Bakersfield_Atrium_final_web_09.jpg" />
            </div>

            <h3 className="title">What you get when you work with us</h3>
            <div className="pg-servicesItems">
              <ContactServicesItems
                services={[
                  {
                    title: "PROJECT-BASED QUOTING",
                    image: features0,
                    width: "50",
                    height: "38",
                    details:
                      "Ask us for a free Preliminary Budget Estimate to furnish your whole space and realize Bulk Discounts through project based pricing. Monthly financing on your Furniture Package is also available!"
                  },
                  {
                    title: "FREE SPACE PLANNING",
                    image: features1,
                    width: "50",
                    height: "30",
                    details:
                    "We’re excited to show how easy it is to transform your office into an active, adaptable workspace. Our\
                    design experts are standing by to provide you with a free space plan that demonstrates how our modern\
                    furniture designs can help you overcome your business challenges."
                  },
                  {
                    title: "CUSTOM TOUCHES",
                    image: features2,
                    width: "50",
                    height: "32",
                    details:
                      "All our customers are assigned a dedicated Project Consultant to provide personalized service\
                      throughout the planning process at no charge. The Modern Furniture Designs that you see on our\
                      website come in numerous finishes, sizes and configurations. Your Project Consultant will work with you\
                      to incorporate the proper sizes within your furniture plan as well as help you navigate and select the\
                      best design options that work optimally with your space, design vision, lead time requirement and\
                      budget."
                  },
                  {
                    title: "DELIVERY & INSTALLATION",
                    image: features3,
                    width: "50",
                    height: "30",
                    details:
                      "Instead of trying to coordinate multiple furniture deliveries & installations through numerous vendors, we can be your single source for planning and purchasing your modern workplace furnishings all the way through coordinating a single delivery and installation."
                  }
                ]}
              />
            </div>
          </div>

          <div className="pg-contact-logos">
          <h3 className="title">Our clients include</h3>
          <div className="pg-contact-logoStrip">
              {[
                  { name: "Variety", image: "contact/logo-variety.png" },
                  { name: "The Disney Company", image: "contact/logo-disney.png" },
                  { name: "Tesla Motors", image: "contact/logo-tesla.png" },
                  { name: "Ocean Spray", image: "contact/logo-ocean-spray.png" },
                  { name: "Direct TV", image: "contact/logo-direct-tv.png" },
                  { name: "Hyatt Regency", image: "contact/logo-hyatt.png" },
                  { name: "Porsche", image: "contact/logo-porsche.png" },
                  { name: "Toyota Motors", image: "contact/logo-toyota.png" }
              ].map((item, i) =>
                  <div className="tile" key={i}>
                    <picture>
                      <source srcSet={`${Payload.webp}/${item.image}.webp`} type="image/webp"/>
                      <source srcSet={`${Payload.static}/${item.image}`} type="image/jpg"/>
                      <img key={`${Payload.static}/${item.image}`} src={`${Payload.static}/${item.image}`} alt={item.name} width="130" height="130"/>
                    </picture>
                  </div>
              )}
          </div>
        </div>

          <ContactVideoBlock />
          <div className="pg-testimonials">
              {[
                {
                  title: "Glenn Kalison",
                  subtitle: "CEO RELATIVITY EDUCATION",
                  image: "contact/test-glenn.jpg",
                  details: (
                    <p>
                      "In the end, sleek and efficient designs created greater
                      functionality conducive to a cutting-edge educational
                      environment.{" "}
                      <b>
                        The sleek, modern, value furniture solutions that
                        StrongProject recommended
                      </b>{" "}
                      for Relativity School resulted in an aesthetic that was far
                      richer than the price tag itself—
                      <b>
                        all of which added to the brand and helped tell the
                        school’s unique story.""
                      </b>
                    </p>
                  )
                },
                {
                  title: "Dierdre Bronchick",
                  subtitle: "INTERIOR DESIGNER, COVE STREET CAPITAL",
                  image: "contact/test-dierdre.jpg",
                  details: (
                    <p>
                      “<b>StrongProject had everything that we wanted.</b>{" "}
                      Investment companies are now thinking outside of the box and
                      we didn’t want to do the standard banker’s office.{" "}
                      <b>
                        I came to them with a list of requirements from the
                        client, and StrongProject was able to source it, and stay
                        on budget.
                      </b>
                      ”
                    </p>
                  )
                },
                {
                  title: "Yvonne Tung",
                  subtitle: "EXECUTIVE VICE PRESIDENT, TRANSGLOBAL",
                  image: "contact/test-yvonne.jpg",
                  details: (
                    <p>
                      “I’ve worked with a lot of different vendors in different
                      cities. <b>StrongProject is very different</b>, because the
                      first thing they do is not recommend furniture to us but to
                      understand what kind of business we’re in and what kind of
                      office we’re going to have...
                      <b>
                        when I work with StrongProject, I feel the professionalism
                        they provide, I feel the passion from their staff, and I
                        feel their products are incomparable
                      </b>
                      . I am so happy about this experience.”
                    </p>
                  )
                },
                {
                  title: "Grant Kirkwood",
                  subtitle: "CEO UNITAS GLOBAL",
                  image: "contact/test-grant.jpg",
                  details: (
                    <p>
                      If the overall team dynamics and goals aren’t considered
                      during the planning phase, it can go horribly wrong.
                      <b>
                        StrongProject engaged with the people on our team
                        throughout, making sure we accomplished our goals.
                        StrongProject has been with us throughout the entire
                        process.
                      </b>
                    </p>
                  )
                }
              ].map((item, i) =>
                  <div className="testimonialItem" key={i}>
                    <div className="testimonialTitleWrapper">
                      <div className="testimonialImage">
                        <picture>
                          <source srcSet={`${Payload.webp}/${item.image}.webp`} type="image/webp"/>
                          <source srcSet={`${Payload.static}/${item.image}`} type="image/jpg"/>
                          <img key={`${Payload.static}/${item.image}`} src={`${Payload.static}/${item.image}`} width="80" height="80" alt={item.title} />
                        </picture>
                      </div>
                      <div className="testimonialTitle">{item.title}</div>
                      <div className="testimonialSubTitle">{item.subtitle}</div>
                    </div>
                    <div className="testimonialDetails">{item.details}</div>
                  </div>
              )}
          </div>
          
          <div className="call-to-action">
              <h3 className="title">Let's Furnish Your Office Now</h3>
              <a href="/office-furniture-dealer-los-angeles#form" className="contact-btn">START THE CONVERSATION</a>
          </div>

          <ContactMethods/>
                {this.props.children}
        </div>
            
        );
    }
});

var ItemOpenGraph = ({ productPage }) => {
    const { splash, story } = productPage.item.descriptions;
    return (
        <Helmet>
            <meta property='og:title' content={`${productPage.breadcrumbs[0].name} by StrongProject Inc.`} />
            <meta property='og:image' content={`https:${Payload.release.media}${productPage.item.filename}`} />
            <meta property='og:image' content={`https:${Payload.release.media}`} />
            {(splash || story) && (
                <meta property='og:description' content={`${splash ? splash : ''} ${story ? story : ''}`} />
            )}
        </Helmet>
    );
}

var ItemSchema = (props) => {
    var jsonLD = {
        "@context" : "http://schema.org",
        "@type" : "Product",
        "name" : `Item ${props.itemID}`,
        "url" : `${Constants.site}${props.url}`,
        "image" : `${Payload.release.media}${props.image}`,
        "description" : props.desc,
        "brand" : {
            "@type" : "Brand",
            "name" : "STRONGPROJECT INC.",
            "logo" : "https://strongproject.com/static/images/header/strongproject-logo.png"
        },
    };
    return (
        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLD) }} />
    );
};

module.exports = ReactRouter.withRouter(ProductDetail);



// WEBPACK FOOTER //
// ./src/collections/product/experiment-product-page-with-form-product-page.jsx